var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{attrs:{"app":"","dark":"","color":"grey darken-3"}},[_c('span',{staticClass:"caption"},[_vm._v("© 2020 Isigma Asesoría tecnológica, S.L. - "),_c('a',{staticClass:"blue--text text--lighten-4",attrs:{"href":"https://www.isigma.es"}},[_vm._v("www.isigma.es")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }